import { useEffect, useRef, useState } from 'react';
import './index.css';

function FormRadio({classRadio='',label='', data, selectDataIndex, handleSelect, required= false, placeholder}){
  const [statusDropdown, setStatusDropdown] = useState(false);

  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setStatusDropdown(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [ref]);

  function dropdown(){
    setStatusDropdown(!statusDropdown);
  }
  return (
    <>  
      <div className={classRadio + ' pt-4 mt-1'}>
        <label style={{paddingLeft:'12px'}} className='form_label' htmlFor="">{label} {required == true && <span style={{color: 'red'}}>*</span> }</label>
        <div className="dropdown-form" ref={ref}>
        <button onClick={dropdown} className='form_radio_title'><div className={selectDataIndex === null ? "content_placeholder_project" : "content_name_project"}>{selectDataIndex === null || selectDataIndex === undefined ? placeholder : data[selectDataIndex]} </div> <img className="img_right" src="./dashboard/Vector_dropdown.svg"></img></button>
          {statusDropdown &&
            <div className="dropdown-content-form">
              {data.map((project, index) => {
                return (
                  <div key={index}>
                    <input  type="radio" id={index} name={index} onClick={() => {
                      handleSelect(index);
                      dropdown();
                    }}/>
                    <label htmlFor={index}>{project}</label> 
                  </div>
                )
              })} 
            </div>  
          }
      </div>
      </div>
    </>
  );
}

export default FormRadio;